import { render, staticRenderFns } from "./languageKey.vue?vue&type=template&id=3a5dbf00"
import script from "./languageKey.vue?vue&type=script&lang=js"
export * from "./languageKey.vue?vue&type=script&lang=js"
import style0 from "./languageKey.vue?vue&type=style&index=0&id=3a5dbf00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports